module.exports = __webpack_public_path__ + "img/InstrumentWarning.f58907cf.svg";